import { render, staticRenderFns } from "./ChannelEdit.vue?vue&type=template&id=c60e63e4&scoped=true"
import script from "./ChannelEdit.vue?vue&type=script&lang=js"
export * from "./ChannelEdit.vue?vue&type=script&lang=js"
import style0 from "./ChannelEdit.vue?vue&type=style&index=0&id=c60e63e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60e63e4",
  null
  
)

export default component.exports